// extracted by mini-css-extract-plugin
export default {"button":"Button_button__NzdWo","green":"Button_green__gHUt4 Button_button__NzdWo","white":"Button_white__phjbZ Button_button__NzdWo"};